const AOS = require("aos");
require("select2");

// Check if we're in the WordPress editor/admin
function isWordPressEditor() {
  return (
    typeof window !== "undefined" &&
    (window.location.pathname.includes("/wp-admin/") ||
      window.location.pathname.includes("/wp-admin/post.php") ||
      window.frameElement !== null ||
      document.body.classList.contains("block-editor-page") ||
      document.getElementById("editor") !== null ||
      (typeof wp !== "undefined" && wp.blocks !== undefined))
  );
}

// If we're in the editor, only initialize Select2 and exit
if (isWordPressEditor()) {
  console.log("WordPress editor detected - loading minimal scripts only");

  // Only initialize Select2 for select elements within ACF block previews, not editing fields
  jQuery(document).ready(function ($) {
    const selectOptions = {
      minimumResultsForSearch: Infinity,
      placeholder: "Select",
    };

    // Only target select elements inside block previews, not ACF fields
    $(".acf-block-preview select").select2(selectOptions);

    // Re-initialize when blocks are updated
    if (window.acf) {
      window.acf.addAction("render_block_preview", function () {
        // Small delay to ensure DOM is ready
        setTimeout(function () {
          $(".acf-block-preview select")
            .not(".select2-hidden-accessible")
            .select2(selectOptions);
        }, 100);
      });
    }
  });

  // Exit early - don't load any other frontend scripts
} else {
  // All frontend functionality below - only runs on actual site pages

  // Document-level top of an element. When the GSAP smooth scroll is active
  // the content lives in a fixed, translated wrapper, so measure against the
  // wrapper rather than the window.
  function getDocumentTop(element) {
    const wrapper = document.querySelector("[data-smooth-wrapper]");
    const top = element.getBoundingClientRect().top;

    if (window.smoothScrollActive && wrapper && wrapper.contains(element)) {
      return top - wrapper.getBoundingClientRect().top;
    }

    return top + window.pageYOffset;
  }

  // Scroll the page to an element (or selector). Works with and without the
  // smooth scroll wrapper - use this instead of $(el).offset() / jQuery animate.
  function scrollToElement(target, options) {
    const element =
      typeof target === "string" ? document.querySelector(target) : target;
    if (!element) return false;

    const offset = (options && options.offset) || 0;
    const top = Math.max(getDocumentTop(element) - offset, 0);
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    window.scrollTo({
      top: top,
      // With smooth scroll active the wrapper already eases towards the
      // native scroll position, so jump the native scroll instantly.
      behavior:
        window.smoothScrollActive || prefersReducedMotion ? "instant" : "smooth",
    });

    return true;
  }

  window.acronScrollTo = scrollToElement;

  function getHashTarget(hash) {
    if (!hash || hash.length < 2) return null;

    let id = hash.slice(1);
    try {
      id = decodeURIComponent(id);
    } catch (e) {}

    const element = document.getElementById(id);
    // Skip hidden targets (e.g. Magnific/Lity popup content)
    if (!element || element.getClientRects().length === 0) return null;

    return element;
  }

  // Same-page #hash links
  document.addEventListener("click", function (e) {
    if (e.defaultPrevented || e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    const link = e.target.closest("a[href*='#']");
    if (!link || link.hasAttribute("data-lity")) return;
    if (link.target && link.target !== "_self") return;

    const url = new URL(link.href, window.location.href);
    if (
      url.origin !== window.location.origin ||
      url.pathname !== window.location.pathname ||
      url.search !== window.location.search
    ) {
      return;
    }

    const targetElement = getHashTarget(url.hash);
    if (!targetElement) return;

    e.preventDefault();
    if (window.location.hash !== url.hash) {
      history.pushState(null, "", url.hash);
    }
    scrollToElement(targetElement);
  });

  // Back/forward between hashes
  window.addEventListener("popstate", function () {
    const targetElement = getHashTarget(window.location.hash);
    if (targetElement) scrollToElement(targetElement);
  });

  // Hash in the URL on page load - wait for layout (images, smooth scroll
  // wrapper height) to settle first
  window.addEventListener("load", function () {
    if (!window.location.hash) return;

    setTimeout(function () {
      const targetElement = getHashTarget(window.location.hash);
      if (targetElement) scrollToElement(targetElement);
    }, 150);
  });

  // Helper function to determine if smooth scroll should be enabled
  function shouldEnableSmoothScroll() {
    // Disable on mobile devices for better performance
    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      ) || window.innerWidth < 768;

    // Disable for users who prefer reduced motion
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    // Disable if touch device (overlaps with mobile but covers tablets)
    const isTouchDevice =
      "ontouchstart" in window || navigator.maxTouchPoints > 0;

    return !isMobile && !prefersReducedMotion && !isTouchDevice;
  }

  // GSAP Smooth Scroll Implementation
  document.addEventListener("DOMContentLoaded", function () {
    // Check if GSAP is loaded
    if (typeof gsap !== "undefined") {
      // Register ScrollTrigger plugin
      gsap.registerPlugin(ScrollTrigger);

      // Site-wide GSAP Smooth Scroll with ScrollTrigger
      if (shouldEnableSmoothScroll()) {
        let currentY = 0;
        let targetY = 0;
        let ease = 0.075;
        let animationFrameId = null;
        let isAnimating = false;

        // Create smooth scroll wrapper
        const smoothWrapper = document.createElement("div");
        smoothWrapper.setAttribute("data-smooth-wrapper", "");
        smoothWrapper.style.position = "fixed";
        smoothWrapper.style.top = "0";
        smoothWrapper.style.left = "0";
        smoothWrapper.style.width = "100%";
        smoothWrapper.style.height = "100%";
        smoothWrapper.style.overflow = "visible";

        // Keep header outside the smooth wrapper to preserve positioning
        const header = document.querySelector(".header");

        // Move all body content to wrapper EXCEPT the header
        const bodyChildren = Array.from(document.body.children);
        bodyChildren.forEach((child) => {
          if (child !== header) {
            smoothWrapper.appendChild(child);
          }
        });

        // Add wrapper to body (header stays in normal flow)
        document.body.appendChild(smoothWrapper);

        // Set body styles for smooth scroll
        document.body.style.height = "100vh";
        document.body.style.overflow = "hidden";

        // Create fake height for scrollbar - batched DOM reads
        let pendingHeightUpdate = false;
        let heightUpdateTimeout = null;

        function updateHeight() {
          if (pendingHeightUpdate) return;
          pendingHeightUpdate = true;

          // Clear any pending timeout
          if (heightUpdateTimeout) {
            clearTimeout(heightUpdateTimeout);
          }

          // Debounce height updates slightly
          heightUpdateTimeout = setTimeout(() => {
            requestAnimationFrame(() => {
              const height = smoothWrapper.scrollHeight;
              document.documentElement.style.height = height + "px";
              pendingHeightUpdate = false;
            });
          }, 16); // ~1 frame delay
        }

        // Optimized smooth scroll animation
        function animate() {
          targetY = window.pageYOffset;

          // Increased threshold to reduce unnecessary updates
          const threshold = 0.5;
          const diff = targetY - currentY;

          if (Math.abs(diff) > threshold) {
            currentY += diff * ease;

            // Use translate3d for better GPU acceleration
            smoothWrapper.style.transform = `translate3d(0, ${-currentY}px, 0)`;

            // Update sticky header with smooth scroll position
            if (window.updateStickyHeader) {
              window.updateStickyHeader(currentY);
            }

            isAnimating = true;
          } else if (isAnimating) {
            // Snap to final position when close enough
            currentY = targetY;
            smoothWrapper.style.transform = `translate3d(0, ${-currentY}px, 0)`;
            isAnimating = false;
          }

          animationFrameId = requestAnimationFrame(animate);
        }

        // Mark smooth scroll as active
        window.smoothScrollActive = true;

        // Initialize
        updateHeight();
        animate();

        // Debounced resize handler
        let resizeTimeout;
        window.addEventListener(
          "resize",
          () => {
            if (resizeTimeout) {
              clearTimeout(resizeTimeout);
            }
            resizeTimeout = setTimeout(updateHeight, 150);
          },
          { passive: true },
        );

        // More efficient MutationObserver - only watch for structural changes
        const observer = new MutationObserver((mutations) => {
          // Only update if actual content was added/removed
          let shouldUpdate = false;
          for (const mutation of mutations) {
            if (
              mutation.type === "childList" &&
              (mutation.addedNodes.length > 0 ||
                mutation.removedNodes.length > 0)
            ) {
              shouldUpdate = true;
              break;
            }
          }
          if (shouldUpdate) {
            updateHeight();
          }
        });

        observer.observe(smoothWrapper, {
          childList: true,
          subtree: true,
          // Removed 'attributes: true' to prevent constant triggering
        });

        console.log("Site-wide GSAP smooth scroll enabled");
      }

      // Add parallax effects to elements with data attributes (always available)
      gsap.utils.toArray("[data-speed]").forEach((element) => {
        const speed = parseFloat(element.dataset.speed) || 0.5;
        gsap.to(element, {
          yPercent: -50 * speed,
          ease: "none",
          scrollTrigger: {
            trigger: element,
            start: "top bottom",
            end: "bottom top",
            scrub: 1.5,
          },
        });
      });

      // Soft float effect for elements with data-float attribute
      gsap.utils.toArray("[data-float]").forEach((element) => {
        const intensity = parseFloat(element.dataset.float) || 20;
        gsap.to(element, {
          y: `random(-${intensity}, ${intensity})`,
          rotation: `random(-2, 2)`,
          duration: `random(3, 5)`,
          ease: "sine.inOut",
          yoyo: true,
          repeat: -1,
          delay: `random(0, 2)`,
        });
      });

      // Enhanced scroll-triggered animations
      gsap.utils.toArray("[data-reveal]").forEach((element) => {
        gsap.fromTo(
          element,
          {
            opacity: 0,
            y: 50,
            scale: 0.98,
          },
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 1.2,
            ease: "power2.out",
            scrollTrigger: {
              trigger: element,
              start: "top 85%",
              end: "bottom 15%",
              toggleActions: "play none none reverse",
            },
          },
        );
      });

      // Add smooth scroll class to html for CSS targeting
      document.documentElement.classList.add("smooth-scroll-enabled");

      console.log("GSAP Smooth Scroll initialized");
    } else {
      console.warn("GSAP not loaded - smooth scroll disabled");
    }
  });

  jQuery(document).ready(function ($) {
    const selectOptions = {
      minimumResultsForSearch: Infinity,
      placeholder: "Select",
    };
    $("select").select2(selectOptions);

    // Define your SVG HTML as a string for a downward facing chevron
    var customSvgArrow = `
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="9.657" height="5.458" viewBox="0 0 9.657 5.458">
      <defs>
        <clipPath id="clip-path">
          <rect id="Rectangle_245" data-name="Rectangle 245" width="9.657" height="5.458" fill="currentColor"/>
        </clipPath>
      </defs>
      <g id="Group_38135" data-name="Group 38135" transform="translate(9.657 5.458) rotate(180)">
        <g id="Group_932" data-name="Group_932" clip-path="url(#clip-path)">
          <path id="Path_273" data-name="Path 273" d="M1.075,5.274,4.829,1.52,8.582,5.274a.63.63,0,1,0,.891-.891l-4.2-4.2a.631.631,0,0,0-.891,0l-4.2,4.2a.63.63,0,0,0,.891.891" transform="translate(0 0)" fill="currentColor"/>
        </g>
      </g>
    </svg>
  `;

    // Delay appending the SVG to ensure Select2 elements are fully initialized
    setTimeout(function () {
      $(
        ".select2-container--default .select2-selection--single, .select2-container--default .select2-selection--multiple",
      ).each(function () {
        var wrapper = document.createElement("div");
        wrapper.innerHTML = customSvgArrow;
        wrapper.style.position = "absolute";
        wrapper.style.top = "50%";
        wrapper.style.right = "12px";
        wrapper.style.transform = "translateY(-50%)";
        wrapper.style.display = "flex";
        wrapper.style.alignItems = "center";
        wrapper.style.justifyContent = "center";

        // Ensures the custom arrow is correctly positioned within Select2
        this.style.position = "relative";
        this.appendChild(wrapper);
      });
    }, 100); // Adjust delay as necessary
  });

  // Start AOS as soon as the DOM is ready - waiting for window load keeps
  // [data-aos] content hidden until every image/font has downloaded
  jQuery(function () {
    AOS.init({
      duration: 800,
      once: true,
    });

    window.AOS = AOS;
  });

  // Recalculate trigger positions once images have loaded and changed the layout
  jQuery(window).on("load", function () {
    AOS.refresh();
  });
}
